import { listIntegrationDefinitions } from '@next-adapter/integration-registry.js'

export function listAvailableIntegrations() {
  return listIntegrationDefinitions()
}
